// Module
var code = `<div class="customer-header box">

  <div class="profile-image fake-picture"
       ng-class="{'image-exists': \$ctrl.customerProfile.pictureFileId}"
       ng-click="\$ctrl.customerProfile.pictureFileId && \$ctrl.showAvatar()"></div>

  <div class="customer-header__section customer-header__section--bigger">
    <span class="title">Name:</span>
    <span class="value trim" title="{{\$ctrl.customerName}}">{{\$ctrl.customerName}}</span>
  </div>

  <div class="customer-header__section customer-header__section--smaller">
    <span class="title">CIF:</span>
    <span class="value">{{\$ctrl.customerNumber}}</span>
  </div>

  <div class="customer-header__section customer-header__section--smaller">
    <span class="title">Mother Branch:</span>
    <span class="value">{{\$ctrl.branchName}}</span>
  </div>

  <div class="customer-header__section customer-header__section--bigger" ng-if="\$ctrl.screen === 'PROFILE'">
    <span class="title">Last updated by:</span>
    <span class="value">{{\$ctrl.updatedBy}}</span>
  </div>

  <div class="customer-header__section customer-header__section--bigger" ng-if="\$ctrl.screen === 'PROFILE'">
    <span class="title">Last updated on:</span>
    <span class="value">{{\$ctrl.updatedAt | prettyDateTime}}</span>
  </div>

  <div class="customer-header__section" ng-if="\$ctrl.signatureFileId() && \$ctrl.screen === 'PROFILE'">
    <a class="btn btn-success"
      ng-click="\$ctrl.showSignature()">
      <i class="icon-pencil icon-white"></i> Customer signature
    </a>
  </div>

  <div class="transcluded" ng-transclude></div>
</div>

<zoomable-picture
  ng-if="\$ctrl.signatureType === 'IMAGE' && \$ctrl.showPopup"
  ng-click="\$ctrl.showPopup = false"
  source-url="\$ctrl.signature"
  description="'Signature'">
</zoomable-picture>

<pdf-view
  ng-if="\$ctrl.signatureType === 'PDF' && \$ctrl.showPopup"
  ng-click="\$ctrl.showPopup = false"
  source-url="\$ctrl.signature"
  description="'Signature'">
</pdf-view>

<zoomable-picture
  ng-if="\$ctrl.showProfilePopup"
  ng-click="\$ctrl.showProfilePopup = false"
  source-url="\$ctrl.profilePicture">
</zoomable-picture>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/customer-profile-header.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;